var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGanttIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 53,
    viewBox: "0 0 68 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5027 2.09082H38.2656V8.68872H47.5027V2.09082Z",
    fill: "#2B6299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6699 2.09082H0V8.68872H31.6699V2.09082Z",
    fill: "#2B6299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6694 12.6475H13.1953V19.2454H31.6694V12.6475Z",
    fill: "#8CBFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7398 33.7607H38.2656V40.3586H56.7398V33.7607Z",
    fill: "#8CBFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6682 44.3174H25.0703V50.9153H31.6682V44.3174Z",
    fill: "#2B6299"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5027 44.3174H38.2656V50.9153H47.5027V44.3174Z",
    fill: "#2B6299"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2964 23.2041H38.2656V29.802H67.2964V23.2041Z",
    fill: "#3B82C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6685 23.2041H18.4727V29.802H31.6685V23.2041Z",
    fill: "#3B82C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6282 0.770996H34.3086V52.2346H35.6282V0.770996Z",
    fill: "#B3B3B3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttIcon);
export default __webpack_public_path__ + "static/media/gantt_icon.b4a360be.svg";
export { ForwardRef as ReactComponent };